import GenericScreen from "../../../GenericScreen";
import { Box } from "@mui/material";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";

import imgScreen from "../../../../../../Assets/StoryPassenger/PHONE_11.jpg";

import connectWithDispatch from "../../../../../../Hooks/connectWithDispatch";

import * as appActions from "../../../../../../Actions/appActions";

interface ScreenProps {
  transition: number;
  screen: number;
  setStory: (value: Partial<StoryType>) => void;
}

const Screen = (props: ScreenProps) => {
  const { transition, setStory, screen } = props;

  const handleNextScreen = () => setTimeout(() => setStory({ screen: screen + 1 }), 1000);
  const handleBackScreen = () => setTimeout(() => setStory({ screen: screen - 1 }), 1000);

  return (
    <>
      <GenericScreen
        showComponent={transition >= 4}
        showContent={true}
        icon={<PersonOutlineIcon sx={styles.icon} />}
        title={"Select your preferred seat"}
        text={"Looks like 2b will be convienient for mum to ask for assistance"}
        panelRight={<PhoneScreenOne handleBackScreen={handleBackScreen} handleNextScreen={handleNextScreen} />}
      />
    </>
  );
};

const styles = {
  icon: {
    fontSize: "5.2083em",
    color: "#00B28F",
  },
  imgScreen: {
    objectFit: "contain" as "contain",
    width: "100%",
    borderRadius: "26px",
  },
};

interface PhoneScreenOneProps {
  handleBackScreen: () => void;
  handleNextScreen: () => void;
}

const PhoneScreenOne = (props: PhoneScreenOneProps) => {
  return (
    <Box sx={{ position: "relative" }}>
      <Box
        onClick={props.handleBackScreen}
        sx={{ cursor: "pointer", position: "absolute", top: "41.5vh", width: "4.7vh", height: "4.9vh", left: "10.35vh" }}
      ></Box>

      <Box
        onClick={props.handleNextScreen}
        sx={{ cursor: "pointer", position: "absolute", bottom: "9vh", width: "33.3vh", height: "6.5vh", left: "3.6vh" }}
      ></Box>
      <img style={styles.imgScreen} src={imgScreen} alt="" />
    </Box>
  );
};

const mapStateToProps = (state: StateType) => {
  return {
    transition: state.appReducer.story.transition,
    screen: state.appReducer.story.screen,
  };
};

const mapDispatchToProps: MapDispatchToProps = {
  setStory: appActions.setStory,
};

export default connectWithDispatch(Screen, mapStateToProps, mapDispatchToProps);
